import React from "react"

import { Card } from 'react-bootstrap'

export const About = (props) => {

    const { myGroupState } = props.state;

    return (
        <div>
            <Card style={{ width: '40rem', margin: '0 auto', float: 'none', marginBottom: '10px' }}>
                <Card.Body>
                    <Card.Title><h5 style={{ fontSize: '1.75rem' }}><b>Group Name: {myGroupState.groupname}</b></h5><h4>Admin: {myGroupState.groupadmin}</h4></Card.Title>
                    <Card.Subtitle className="mb-2 text-muted">Total Members: {myGroupState.totalmembers}</Card.Subtitle>
                    <Card.Text>
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                    </Card.Text>
                </Card.Body>
            </Card>
        </div>

    )
}
